import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SkillsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.SkillsFilters>;
}>;


export type SkillsQuery = { skills: { edges?: Array<{ node: { id: string, name: string, maxScore?: number | null, description?: string | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ description?: string | null, label: string, score?: number | null, maxScore?: number | null, minScore?: number | null }> } }> | null } };


export const SkillsDocument = /*#__PURE__*/ gql`
    query skills($filters: SkillsFilters) {
  skills(filters: $filters, first: -1) {
    edges {
      node {
        id
        name
        maxScore
        description
        scaleConfig {
          maxScore
          minScore
          scaleType
        }
        rubrics {
          description
          label
          score
          maxScore
          minScore
        }
      }
    }
  }
}
    `;

export function useSkillsQuery(options?: Omit<Urql.UseQueryArgs<SkillsQueryVariables>, 'query'>) {
  return Urql.useQuery<SkillsQuery, SkillsQueryVariables>({ query: SkillsDocument, ...options });
};